export enum FacadeTrimBehavior {
  REMOVE = "REMOVE",
  ADD = "ADD",
}

export enum SpanExtrema {
  BASE_WALL_BOTTOM = "base_wall_bottom",
  BASE_WALL_TOP = "base_wall_top",
  GABLE_END_BOTTOM = "gable_end_bottom",
  GABLE_END_TOP = "gable_end_top",
  WALL_START = "wall_start",
  WALL_END = "wall_end",
}
